export default __webpack_public_path__ + "static/media/sg-icon.f1eeb139.webp";